import _defaultsDeep from "lodash-es/defaultsDeep";
import { theme as chakraTheme } from '@chakra-ui/core';
import defaultTheme from './defaultTheme';
import { spacing, pxToRem } from './util';
import zIndex from './zIndex';
var labColors = {
  primary: '#03427A',
  error: '#DB2828',
  defaultText: '#595959'
};
export var themeUtils = {
  pxToRem: pxToRem,
  spacing: spacing,
  zIndex: zIndex
};
export function getMergedTheme() {
  for (var _len = arguments.length, themes = new Array(_len), _key = 0; _key < _len; _key++) {
    themes[_key] = arguments[_key];
  }

  var d3Theme = _defaultsDeep.apply(void 0, [{}].concat(themes, [defaultTheme, themeUtils]));

  var chakraMappedTheme = {
    colors: {
      primary: d3Theme.palette.primary.main,
      primaryContrast: d3Theme.palette.primary.contrastText,
      // Secondary is the new cta
      secondary: d3Theme.palette.callToAction.main,
      secondaryContrast: d3Theme.palette.callToAction.contrastText,
      // Colors associated with lab components. Doesn't need to connect up to the actual theme
      lab: labColors
    }
  };
  return _defaultsDeep(d3Theme, chakraTheme, chakraMappedTheme);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/theme.js
// module id = 462
// module chunks = 0